import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ArticleSubscriptions = React.lazy(() => import('./index'));
const ArticleSubscriptionTable = React.lazy(() => import('./articleSubscriptionTable'));
const ArticleSubscription = React.lazy(() => import('./articleSubscription'));
const ArticleSubscriptionDetail = React.lazy(() => import('./articleSubscriptionDetail'));

export const useArticleSubscriptionRoutes = () => {

    return (
        <Route path="articleSubscriptions" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleSubscriptions /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleSubscriptionTable/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleSubscription/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleSubscriptionDetail/></Suspense> } />
            </Route>
        </Route>
    )
}